import React, { useState, useEffect } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE } from "baseui/input";
import { styled } from "baseui";
import { LabelMedium } from "baseui/typography";
import InputItem from "../input-item/InputItem";
import { FlexGrid } from "baseui/flex-grid";

const GroupBox = styled("fieldset", ({ $theme }) => ({
  margin: "8px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "start",
  flexWrap: "wrap",
  border: "1px solid silver",
  padding: "10px",
  borderRadius: "4px",
  width: "100%",

  // overflowX: "hidden",
}));

const GroupBody = styled(FlexGrid, ({ $theme }) => ({
  // overflowX: "hidden",
}));

const Legend = styled("legend", ({ $theme }) => ({
  padding: "2px",
  width: "auto",
}));

export default function GroupedInputs(props) {
  const [inputValues, setInputValues] = useState(props.inputValues);

  useEffect(() => {
    setInputValues(props.inputValues);
  }, [props.inputValues]);

  return (
    <GroupBox disabled={props.disabled}>
      <Legend>
        <LabelMedium>{props.label}</LabelMedium>
      </Legend>
      <GroupBody
        flexGridColumnCount={[1, 2, 3, 4]}
        flexGridColumnGap="scale800"
      >
        {props.inputs.map((input, index) => {
          return (
            <InputItem
              disabled={props.disabled}
              key={index}
              description={input.description}
              label={() => input.label}
              type={input.inputType}
              size={SIZE.mini}
              itemMeta={input}
              itemValue={
                inputValues?.find((iv) => iv.itemName === input.name)?.itemValue
              }
              itemName={input.name}
              onApplyChange={(itemName, itemValue) =>
                props.onInputValueChange(props.label, itemName, itemValue)
              }
            />
          );
        })}
      </GroupBody>
    </GroupBox>
  );
}
